module.exports = __webpack_public_path__ + "img/city-icon.1c9e3211.svg";